export const ChatIcon = ({ color = "#fff" }) => {
  return (
    <svg
      width="34"
      height="31"
      viewBox="0 0 34 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3108 8.72266V13.4593M17.3108 13.4593V18.1959M17.3108 13.4593H22.0474M17.3108 13.4593H12.5742"
        stroke={color}
        strokeWidth="1.57382"
        strokeLinecap="round"
      />
      <path
        d="M20.4698 26.091C26.4237 26.091 29.4015 26.091 31.2503 24.2405C33.1008 22.3917 33.1008 19.4139 33.1008 13.46C33.1008 7.50613 33.1008 4.52838 31.2503 2.67953C29.4015 0.829101 26.4237 0.829102 20.4698 0.829102H14.1544C8.20046 0.829102 5.22272 0.829101 3.37387 2.67953C1.52344 4.52838 1.52344 7.50613 1.52344 13.46C1.52344 19.4139 1.52344 22.3917 3.37387 24.2405C4.40487 25.2731 5.78638 25.7294 7.8389 25.9299"
        stroke={color}
        strokeWidth="1.57382"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4679 26.0919C18.5164 26.0919 16.366 26.8814 14.4035 27.8997C11.2489 29.537 9.6716 30.3565 8.8948 29.8338C8.118 29.3128 8.26483 27.6945 8.56008 24.4594L8.62639 23.7236"
        stroke={color}
        strokeWidth="1.57382"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EmoteIcon = ({ color = "#fff" }) => {
  return (
    <svg
      width="21"
      height="35"
      viewBox="0 0 21 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.2458 0.26714C0.562818 0.507672 0.134769 1.02143 0.0407195 1.71329C-0.00988427 2.08568 0.201435 3.36802 0.481836 4.38955C1.2106 7.04469 2.49001 9.24169 4.37541 11.0758L5.17775 11.8562L5.17816 15.769L5.17858 19.6819L4.96851 20.2328C4.70367 20.9272 4.23192 22.7057 4.04183 23.7267C3.93388 24.3065 3.89601 24.9506 3.89451 26.2323C3.89226 28.1449 4.02485 29.0644 4.5273 30.6235C5.03742 32.2061 6.08121 34.1078 6.6366 34.4668C7.93956 35.3088 9.61931 34.3942 9.60674 32.8496C9.60374 32.4812 9.53524 32.2739 9.2188 31.6764C8.55821 30.4287 8.17469 29.1926 7.92483 27.5056C7.75171 26.3368 7.82637 23.5042 8.06341 22.248C8.12417 21.9258 8.66757 21.1512 8.93024 21.0124C9.32109 20.806 9.77803 21.4481 10.0782 22.6258C10.1691 22.9828 10.3406 23.8109 10.4591 24.4661C10.7243 25.9322 10.9843 27.1054 11.1462 27.5679C11.433 28.387 12.3809 28.898 13.2992 28.7286C14.029 28.5941 17.4573 26.6811 19.0363 25.5275C20.2004 24.677 20.4929 24.2807 20.4929 23.554C20.4929 22.4271 19.708 21.6406 18.5786 21.6356C17.9667 21.6329 17.7728 21.722 16.684 22.5067C16.0379 22.9723 14.2751 24.0553 14.1632 24.0553C14.1304 24.0553 14.0845 23.9722 14.0611 23.8705C14.0378 23.7688 13.8083 22.8861 13.5512 21.9089L13.0838 20.1322L13.1054 16.1589L13.127 12.1855L15.0413 11.9222C16.0942 11.7774 17.3807 11.604 17.9004 11.5369C19.0098 11.3938 19.354 11.2174 19.718 10.6052C19.9085 10.2848 19.9512 10.1156 19.9515 9.67922C19.9518 9.21951 19.8862 8.98538 19.4798 7.99516C19.2201 7.36261 18.7461 6.03179 18.4264 5.03779C17.6964 2.76858 17.7304 2.85065 17.3762 2.50094C17.0259 2.15534 16.3098 1.9139 15.893 2.00098C15.1275 2.16092 14.6668 2.70845 14.6668 3.45806C14.6668 3.86059 15.2337 5.80711 15.8681 7.5826C16.231 8.59813 16.2334 8.61177 16.0546 8.65095C15.7174 8.72497 12.7881 9.10417 12.5406 9.10581C12.4053 9.1068 10.9464 8.82453 9.29845 8.4786C5.89169 7.76366 6.30593 7.95121 5.32789 6.68077C4.39614 5.47055 3.698 3.79635 3.38672 2.02571C3.19014 0.907246 2.93296 0.494611 2.29184 0.268947C1.89242 0.128308 1.64106 0.127897 1.2458 0.26714ZM8.94897 1.95005C7.62237 2.39645 6.78683 3.76875 7.01163 5.13193C7.2202 6.39703 8.11018 7.29492 9.40457 7.54621C10.5567 7.76999 11.7462 7.26066 12.3735 6.27495C12.7151 5.73811 12.8357 5.31176 12.8357 4.64109C12.8357 2.69407 10.8414 1.31323 8.94897 1.95005Z"
        fill={color}
      />
    </svg>
  );
};

export const VolumeIcon = ({ color = "#fff" }) => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2911 12.4162C25.1879 14.9463 25.1879 19.8471 23.2911 22.3772M27.5601 7.43571C33.235 12.8545 33.2691 21.9745 27.5601 27.3577M3.36914 21.6073V13.1846C3.36914 12.3678 4.00664 11.7047 4.79214 11.7047H9.895C10.0833 11.704 10.2695 11.6652 10.4424 11.5906C10.6153 11.516 10.7714 11.4072 10.9011 11.2707L15.17 6.44957C16.0665 5.51609 17.5991 6.17778 17.5991 7.4969V27.2965C17.5991 28.6255 16.048 29.2815 15.1572 28.3296L10.9025 23.5355C10.7724 23.3951 10.6148 23.2829 10.4395 23.2061C10.2642 23.1292 10.075 23.0892 9.88362 23.0887H4.79214C4.00664 23.0887 3.36914 22.4255 3.36914 21.6073Z"
        stroke={color}
        strokeWidth="1.94854"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LocationIcon = ({ color = "#fff" }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.368 5.78907L6.632 4.87607C6.33133 4.77593 6.01118 4.74867 5.69791 4.79654C5.38464 4.8444 5.08723 4.96603 4.83019 5.15139C4.57315 5.33674 4.36383 5.58053 4.21949 5.86266C4.07516 6.14478 3.99992 6.45717 4 6.77407V18.5571C3.9999 18.977 4.13198 19.3863 4.37752 19.727C4.62305 20.0676 4.96959 20.3224 5.368 20.4551L9.368 21.7881C9.77825 21.9247 10.2217 21.9247 10.632 21.7881L15.368 20.2101C15.7783 20.0734 16.2217 20.0734 16.632 20.2101L19.368 21.1221C19.6687 21.2222 19.989 21.2495 20.3023 21.2016C20.6157 21.1536 20.9132 21.0319 21.1702 20.8465C21.4273 20.661 21.6366 20.4171 21.7808 20.1348C21.9251 19.8526 22.0002 19.5401 22 19.2231V7.44107C22.0002 7.02126 21.8682 6.61205 21.6229 6.2714C21.3775 5.93075 21.0312 5.67594 20.633 5.54307L16.633 4.21007C16.2224 4.07321 15.7786 4.07321 15.368 4.21007L10.631 5.78807C10.2207 5.92471 9.77725 5.92471 9.367 5.78807L9.368 5.78907Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6V22M16 4V20"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationIcon = ({ color = "#fff" }) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1018_3970)">
        <path
          d="M16.9748 13.7742L15.3123 11.1854V7.51606C15.3714 6.54041 15.1386 5.56879 14.6409 4.71352C14.1432 3.85825 13.4009 3.15426 12.4998 2.68293C12.5121 2.53274 12.5121 2.38187 12.4998 2.23168C12.4901 1.9291 12.4177 1.63131 12.2868 1.35532C12.1559 1.07933 11.969 0.830556 11.7368 0.623221C11.5046 0.415886 11.2317 0.254055 10.9336 0.146979C10.6356 0.039902 10.3183 -0.0103204 9.99976 -0.000817724C9.68126 -0.0103204 9.36392 0.039902 9.06587 0.146979C8.76782 0.254055 8.49491 0.415886 8.26273 0.623221C8.03055 0.830556 7.84366 1.07933 7.71275 1.35532C7.58183 1.63131 7.50946 1.9291 7.49976 2.23168C7.48135 2.38159 7.48135 2.53302 7.49976 2.68293C6.59861 3.15426 5.85627 3.85825 5.35857 4.71352C4.86087 5.56879 4.62813 6.54041 4.68726 7.51606V11.1854L3.02476 13.7742C2.88095 13.9986 2.80241 14.2552 2.79716 14.5179C2.7919 14.7806 2.86013 15.0399 2.99486 15.2693C3.12959 15.4987 3.32601 15.6901 3.56405 15.8238C3.80209 15.9575 4.07322 16.0288 4.34976 16.0304H6.56226C6.62009 16.8515 7.01041 17.6193 7.65133 18.1728C8.29225 18.7263 9.13393 19.0225 9.99976 18.9992C10.8656 19.0225 11.7073 18.7263 12.3482 18.1728C12.9891 17.6193 13.3794 16.8515 13.4373 16.0304H15.6498C15.9263 16.0288 16.1974 15.9575 16.4355 15.8238C16.6735 15.6901 16.8699 15.4987 17.0047 15.2693C17.1394 15.0399 17.2076 14.7806 17.2024 14.5179C17.1971 14.2552 17.1186 13.9986 16.9748 13.7742ZM9.06226 2.23168C9.08448 2.01527 9.19508 1.81575 9.37033 1.6759C9.54558 1.53605 9.77154 1.467 9.99976 1.48356C10.228 1.467 10.4539 1.53605 10.6292 1.6759C10.8044 1.81575 10.915 2.01527 10.9373 2.23168C10.6251 2.21311 10.312 2.21311 9.99976 2.23168C9.68757 2.21279 9.37444 2.21279 9.06226 2.23168ZM9.99976 17.5148C9.54809 17.5364 9.10441 17.3957 8.75699 17.1206C8.40957 16.8456 8.18386 16.4564 8.12476 16.0304H11.8748C11.8157 16.4564 11.5899 16.8456 11.2425 17.1206C10.8951 17.3957 10.4514 17.5364 9.99976 17.5148ZM4.34976 14.5461L6.02476 11.9692L6.24976 11.6011V7.51606C6.24675 6.62674 6.50661 5.75448 6.99976 4.99856C7.34003 4.55553 7.79505 4.20355 8.32067 3.97676C8.84629 3.74998 9.42469 3.65608 9.99976 3.70418C10.5748 3.65608 11.1532 3.74998 11.6788 3.97676C12.2045 4.20355 12.6595 4.55553 12.9998 4.99856C13.4929 5.75448 13.7528 6.62674 13.7498 7.51606V11.6011L13.9748 11.9692L15.6498 14.5461H4.34976Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1018_3970">
          <rect width="20" height="19" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default function CloseIcon({ color = "#fff", size = "22" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7502 12.1641L1.70718 21.2071L0.292969 19.7928L9.33594 10.7499L0.293121 1.70706L1.70733 0.292847L10.7502 9.33566L19.793 0.292847L21.2072 1.70706L12.1644 10.7499L21.2073 19.7928L19.7931 21.2071L10.7502 12.1641Z"
        fill={color}
      />
    </svg>
  );
}

export const PlayIcon = ({ color = "#fff" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 64 64"
    >
      <polygon
        fill="none"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="4"
        points="50.25 32 15.75 55 15.75 9 50.25 32"
      />
    </svg>
  );
};
export const PauseIcon = ({ color = "#fff" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 64 64"
    >
      <line
        x1="22"
        x2="22"
        y1="8"
        y2="56"
        fill="none"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <line
        x1="42"
        x2="42"
        y1="8"
        y2="56"
        fill="none"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="4"
      />
    </svg>
  );
};

export const ExitScreenIcon = ({ color = "#fff" }) => {
  return (
    <svg
      height="14px"
      version="1.1"
      viewBox="0 0 14 14"
      width="14px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsSketch="http://www.bohemiancoding.com/sketch/ns"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title />
      <desc />
      <defs />
      <g
        fill="none"
        fillRule="evenodd"
        id="Page-1"
        stroke="none"
        strokeWidth="1"
      >
        <g
          fill={color}
          id="Core"
          transform="translate(-257.000000, -257.000000)"
        >
          <g id="fullscreen-exit" transform="translate(257.000000, 257.000000)">
            <path
              d="M0,11 L3,11 L3,14 L5,14 L5,9 L0,9 L0,11 L0,11 Z M3,3 L0,3 L0,5 L5,5 L5,0 L3,0 L3,3 L3,3 Z M9,14 L11,14 L11,11 L14,11 L14,9 L9,9 L9,14 L9,14 Z M11,3 L11,0 L9,0 L9,5 L14,5 L14,3 L11,3 L11,3 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const FullFullScreen = ({ color = "#fff" }) => {
  return (
    <svg
      height="14px"
      version="1.1"
      viewBox="0 0 14 14"
      width="14px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsSketch="http://www.bohemiancoding.com/sketch/ns"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title />
      <desc />
      <defs />
      <g
        fill="none"
        fillRule="evenodd"
        id="Page-1"
        stroke="none"
        strokeWidth="1"
      >
        <g
          fill={color}
          id="Core"
          transform="translate(-215.000000, -257.000000)"
        >
          <g id="fullscreen" transform="translate(215.000000, 257.000000)">
            <path
              d="M2,9 L0,9 L0,14 L5,14 L5,12 L2,12 L2,9 L2,9 Z M0,5 L2,5 L2,2 L5,2 L5,0 L0,0 L0,5 L0,5 Z M12,12 L9,12 L9,14 L14,14 L14,9 L12,9 L12,12 L12,12 Z M9,0 L9,2 L12,2 L12,5 L14,5 L14,0 L9,0 L9,0 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
